import { createDictionaryApiFactory, mapDictionaryState } from "./dictionaryApiFactory";

export const mapToClaimReopenReason = mapDictionaryState;

const claimReopenReasonApi = createDictionaryApiFactory("claimReopenReason");

export const getMotiveReopenClaim = claimReopenReasonApi.search;
export const exportCsvMotiveReopenClaim = claimReopenReasonApi.exportCsv;
